import { useQuery } from '@tanstack/react-query';
import { api } from './api';

export interface AuthUser {
  email: string;
  name: string;
  picture: string | null;
}

export function useAuth() {
  const query = useQuery<AuthUser | null>({
    queryKey: ['auth', 'me'],
    queryFn: async () => {
      try {
        return await api<AuthUser>('/api/auth/me');
      } catch {
        return null;
      }
    },
    staleTime: 60_000,
    retry: false,
  });
  return {
    user: query.data ?? null,
    isLoading: query.isLoading,
    isAuthenticated: query.data != null,
    refetch: query.refetch,
  };
}

export function signIn() {
  const returnTo = encodeURIComponent(window.location.pathname);
  window.location.href = `/api/auth/google?returnTo=${returnTo}`;
}

export async function signOut() {
  await fetch('/api/auth/logout', { method: 'POST', credentials: 'include' });
  window.location.href = '/login';
}
